import * as React from 'react';
import { Button, Tooltip as Tt, OverlayTrigger, Placement } from 'react-bootstrap';

export const Tooltip = ({
  placement = 'bottom',
  show = 250,
  hide = 400,
  tooltipLabel,
  variant = 'primary',
  buttonClass = '',
  buttonLabel = '',
  onClick = () => null,
  type = '',
  children
}) => {
  return (
    <OverlayTrigger placement={placement as Placement} delay={{ show, hide }} overlay={<Tt id={tooltipLabel}>{tooltipLabel}</Tt>}>
      {children}
    </OverlayTrigger>
  );
};
